module.exports = __webpack_public_path__ + "img/IMG_0057_L_Wood.03089742.jpg";